<template>
  <el-container class="layout">
    <el-aside width="220px" class="aside">
      <div class="logo">脑智和合</div>
      <el-menu :default-active="active" router background-color="#1f2d3d" text-color="#bfcbd9" active-text-color="#409EFF">
        <el-menu-item v-if="isAdmin" index="/mini-users">小程序用户管理</el-menu-item>
        <el-menu-item v-if="isAdmin" index="/platform-users">平台用户管理</el-menu-item>
        <el-menu-item v-if="isAdmin" index="/roles">角色管理</el-menu-item>
        <el-menu-item v-if="isAdmin" index="/functional-results">测评记录管理</el-menu-item>
        <el-menu-item v-if="isAdmin" index="/banners">轮播图管理</el-menu-item>
        <el-menu-item v-if="isAdmin" index="/articles">文章管理</el-menu-item>
        <el-menu-item index="/cs" class="menu-cs-item">
          <span class="menu-cs-label">客服</span>
          <el-badge v-if="csUnread > 0" :value="csUnread" :max="99" class="menu-cs-badge" />
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <span class="header-title">{{ title }}</span>
        <el-dropdown trigger="click" placement="bottom-end" popper-class="header-user-dropdown" @command="onDropCommand">
          <span class="user-trigger">
            <span class="user-avatar">{{ avatarChar }}</span>
            <span class="user-trigger-name">{{ triggerTitle }}</span>
            <i class="el-icon-arrow-down user-caret" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item disabled class="dd-role-item">{{ menuRoleLine }}</el-dropdown-item>
            <el-dropdown-item divided command="logout" class="dd-logout-item">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import http from '../api/http';

export default {
  name: 'LayoutView',
  data() {
    return {
      csUnread: 0
    };
  },
  computed: {
    active() {
      return this.$route.path;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    /** 头像内单字：与触发条主文案一致取首字 */
    avatarChar() {
      const t = this.triggerTitle;
      if (!t) return '?';
      return String(t).trim().charAt(0) || '?';
    },
    /** 触发区域主文案（参考图：在线客服 / 管理员名称） */
    triggerTitle() {
      const u = this.$store.state.user;
      if (!u) return '';
      if (u.roleCode === 'CS') return '在线客服';
      return (u.displayName || u.username || u.roleName || '管理员').trim() || '管理员';
    },
    /** 下拉第一层：浅灰，与触发条主文案一致（参考图重复展示） */
    menuRoleLine() {
      return this.triggerTitle;
    },
    title() {
      const m = {
        '/mini-users': '小程序用户',
        '/platform-users': '平台账号',
        '/roles': '角色管理',
        '/functional-results': '测评记录管理',
        '/banners': '轮播图管理',
        '/articles': '文章管理',
        '/cs': '客服工作台'
      };
      return m[this.$route.path] || '';
    }
  },
  async mounted() {
    if (this.$store.state.token && !this.$store.state.user) {
      try {
        await this.$store.dispatch('loadMe');
      } catch {
        this.$store.commit('CLEAR_AUTH');
        this.$router.replace('/login');
        return;
      }
    }
    this.fetchCsUnread();
    this.$root.$on('cs-unread-refresh', this.fetchCsUnread);
  },
  beforeDestroy() {
    this.$root.$off('cs-unread-refresh', this.fetchCsUnread);
  },
  watch: {
    '$route.path'() {
      this.fetchCsUnread();
    }
  },
  methods: {
    async fetchCsUnread() {
      if (!this.$store.state.token) {
        this.csUnread = 0;
        return;
      }
      try {
        const { data } = await http.get('/admin/cs/unread-count');
        const raw = data.data != null ? data.data : data;
        const n = raw && raw.count != null ? Number(raw.count) : 0;
        this.csUnread = Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
      } catch {
        /* 轮询失败不打断界面 */
      }
    },
    onDropCommand(cmd) {
      if (cmd === 'logout') this.logout();
    },
    logout() {
      this.csUnread = 0;
      this.$store.dispatch('logout');
      this.$router.replace('/login');
    }
  }
};
</script>

<style scoped>
.layout {
  height: 100%;
}
.aside {
  background: #1f2d3d;
}
.logo {
  color: #fff;
  font-weight: 600;
  padding: 18px 20px;
  font-size: 16px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  padding: 0 20px;
}
.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.user-trigger {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 10px 6px 6px;
  border-radius: 8px;
  outline: none;
}
.user-trigger:hover {
  background: #f5f7fa;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0d63ee 0%, #0d56cd 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(13, 99, 238, 0.35);
}
.user-trigger-name {
  margin-left: 12px;
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-caret {
  margin-left: 6px;
  font-size: 12px;
  color: #909399;
}
.main {
  background: #f5f7fa;
}
.menu-cs-item {
  position: relative;
}
.menu-cs-label {
  vertical-align: middle;
}
.menu-cs-badge {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
</style>

<style>
/* 下拉挂载在 body，需非 scoped */
.header-user-dropdown.el-dropdown-menu {
  margin-top: 8px !important;
  padding: 10px 0;
  min-width: 180px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 44, 73, 0.12);
  border: 1px solid #ebeef5;
}
.header-user-dropdown.el-dropdown-menu .el-dropdown-menu__item {
  line-height: 22px;
  padding: 12px 20px;
  font-size: 14px;
  text-align: center;
}
.header-user-dropdown.el-dropdown-menu .dd-role-item {
  color: #909399 !important;
  cursor: default !important;
  background: transparent !important;
}
.header-user-dropdown.el-dropdown-menu .dd-role-item:hover {
  background: transparent !important;
  color: #909399 !important;
}
.header-user-dropdown.el-dropdown-menu .dd-logout-item {
  color: #303133 !important;
  font-weight: 500;
}
.header-user-dropdown.el-dropdown-menu .dd-logout-item:hover {
  color: #0d63ee !important;
  background: #ecf5ff !important;
}
.header-user-dropdown[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: #ebeef5 !important;
}
.header-user-dropdown[x-placement^='bottom'] .popper__arrow::after {
  border-bottom-color: #fff !important;
}
</style>

